import FinancialHomePage, { columns1, columns2 } from './FinancialHomePage';

const financialLinks = [...columns1, ...columns2];

export { financialLinks };
export default FinancialHomePage;
